/*
 *
 * For now just a friendly name mapping ... later perhaps the basis for a model factory.
 * Taken from FddObjectTypeDBTranslater -- should be provided in webservice --
 * only including those supported in data services.
 * ( Update: I think only the enums (keys) are in the FddObjectTypeDBTranslater;
 * the descriptions appear manually derived from schema documentation )
 *
 */

module.exports = {
    FDD_COLD_TEXT_OPTREC: 'Text (ANSI)',
    FDD_CF_TEXT_OPTREC: 'Windows Text',
    FDD_COLD_COMPRESS_OPTREC: 'Compressed COLD text',
    FDD_IMAGE_TYPE: 'Native image',
    FDD_GOS_TYPE: 'GOS',
    FDD_FORMSIQ_OPTREC: 'Forms IQ',
    FDD_EML_OPTREC: 'Email',
    FDD_EML_V2_OPTREC: 'Parsed Email',
    FDD_URL_OPTREC: 'URL',
    FDD_UTF8_COMPRESS_OPTREC: 'Compressed COLD UTF8',
    FDD_UTF8_TEXT_OPTREC: 'UTF8',
    FDD_REPORT_OPTREC: 'Report page', //(only FDD support)
    FDD_GOS_V3_OPTREC: 'Multi-part GOS part',
    FDD_GOS_TOC_OPTREC: 'Multi-part GOS skeleton'
};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/page/pageTypeXref.js
 ** module id = 343
 ** module chunks = 0
 **/